import React, { PureComponent } from 'react';
import { compose } from 'redux';
import Marker from 'react-google-maps/lib/components/Marker';
import InfoWindow from 'react-google-maps/lib/components/InfoWindow';
import PropTypes from 'prop-types';
import { toCommaNumber } from 'common/formatters';
import { Card } from 'common/components';

import { withRouter } from 'react-router-dom';
import { history } from 'store';
import { base64url_encode } from 'util/base64';
import { connect } from 'react-redux';
import { isDesktop } from 'common/utils';
import * as constants from 'common/constants';

class MarkerWithInfoWindow extends PureComponent {
  state = { isOpen: this.props.isOpen || false };
  onToggleClose = () => {
    this.setState({ isOpen: false });
  };

  onToggleOpen = () => {
    // on mobile, open the link if window is already open
    if (!isDesktop() && this.state.isOpen) {
      this._onMarkerClick();

      // fake timeout to wait for componentDidUpdate()
      // then open this current info window
    } else {
      this.props.closeAllWindows();
      setTimeout(() => this.setState({ isOpen: true }), 0);
    }
  };

  _onMarkerClick = () => {
    const { match, storage } = this.props;
    if (match.url.match(/\/activity\/add\/(STORAGE)/g)) {
      // Click on marker to choose the storage in activity form
    } else if (
      match.url.match(/\/activity\/add\/(HARVESTING|SCOUTING|FERTILIZING)/g)
    ) {
      // Placeholder for future implementation
    } else {
      const encodedStorageId = base64url_encode(storage.id.trim());
      if (
        !match.params.encodedId ||
        match.params.encodedId !== encodedStorageId
      ) {
        history.push(`${constants.ROUTE_STORAGE_DETAIL}/${encodedStorageId}`);
      }
    }
  };

  componentDidUpdate = prevProps => {
    const { infoWindowFlag } = this.props;
    // if infowindow flag is turned off, close
    if (!infoWindowFlag && prevProps.prevProps !== infoWindowFlag) {
      this.onToggleClose();
    }
  };

  render() {
    const { icon, storage } = this.props;
    const { isOpen } = this.state;
    const infoTitle = storage ? storage.name : '';
    let infoSubTitle = null;

    const capacity = storage ? storage.capacity : {};
    const crop = storage ? storage.crop : {};
    const position = storage ? storage.location : {};

    if (crop) {
      const { name, variety } = crop;
      infoSubTitle = name + (variety ? ` ${variety}` : '');
    }

    const unit = (capacity.type || []).slice(0, 2);
    const freeCapacity = capacity.size - capacity.used;
    const usedCapacity = capacity.used;
    // by default, click to show window, no hover
    // click the title in the window to go to details
    let markerProps = {
      ...this.props.markerProps,
      position,
      icon,
      onClick: this.onToggleOpen,
      // onMouseOut: this.onToggleClose,
    };
    // if desktop, click to go to the details, hover to show window
    if (isDesktop()) {
      markerProps = {
        ...markerProps,
        onClick: this._onMarkerClick,
        onMouseOver: this.onToggleOpen,
      };
    }

    return (
      <Marker {...markerProps}>
        {isOpen && (
          <InfoWindow onCloseClick={this.onToggleClose}>
            <Card>
              {infoTitle && <h5 className={'cardlist__title'}>{infoTitle}</h5>}
              {infoSubTitle}
              <article className={'progress__wrapper'}>
                {
                  <footer className={'progress__unit progress__unit--info'}>
                    {usedCapacity > 0 && (
                      <dl>
                        <dd>
                          {`${toCommaNumber(usedCapacity)} `}
                          <strong>{unit}</strong>
                        </dd>
                        <dt>Filled</dt>
                      </dl>
                    )}
                    <dl>
                      <dd>
                        {toCommaNumber(freeCapacity)} <strong>{unit}</strong>
                      </dd>
                      <dt>Free</dt>
                    </dl>
                  </footer>
                }
              </article>
              <a onClick={this._onMarkerClick} className="card__cover" />
            </Card>
          </InfoWindow>
        )}
      </Marker>
    );
  }
}

MarkerWithInfoWindow.propTypes = {
  children: PropTypes.element,
  icon: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  storage: PropTypes.object,
  match: PropTypes.object.isRequired,
  infoWindowFlag: PropTypes.bool.isRequired,
  closeAllWindows: PropTypes.func.isRequired,
  markerProps: PropTypes.object,
};

const mapState = state => ({
  formName: state.map.formName,
});
const enhance = compose(
  connect(mapState),
  withRouter
);

export default enhance(MarkerWithInfoWindow);



// WEBPACK FOOTER //
// ./src/common/components/MapComponent/MarkerWithInfoWindow.js